import { Team } from '@maxpreps/apiserviceclients/apiModels';
import { IPageConfig } from '@maxpreps/shared/models/metaTypes';

interface IContentTitleOptions {
  admin?: boolean;
  mobile?: boolean;
  includeHighSchool?: boolean;
}

const getContentTitle = (
  pageName: string,
  teamData: Team,
  pageConfig?: IPageConfig,
  // doing nothing with mobile yet.
  options: IContentTitleOptions = {
    admin: false,
    mobile: false,
    includeHighSchool: false
  }
) =>
  `${teamData.schoolName} ${options.includeHighSchool ? 'High School' : ''} ${
    teamData.formattedSportSeasonName
  } ${pageName}`;

export default getContentTitle;
